// src/myDashboard/UserSettings.jsx
import React from 'react';
import { Routes, Route, NavLink, Navigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './UserSettings.css';
import AppTransition from '../components/appComponents/AppTransition';
import Sidebar from '../myDashboard/Sidebar';
import CloseSidebar from '../myDashboard/CloseSidebar';
import GeneralSettings from './settingComponent/accountSetting/GeneralSettings';
import IntegrationSetting from './settingComponent/accountSetting/IntegrationSetting';
import PreferenceSetting from './settingComponent/accountSetting/PeferenceSetting';
import WarningSetting from './settingComponent/accountSetting/WarningSetting';
import DescriptionTemplate from './settingComponent/creatorSetting/DescriptionTemplate';
import CommentTemplate from './settingComponent/creatorSetting/CommentTemplate';
import SelectedPlan from './settingComponent/planSetting/selectedPlan';
import ApiGlobalSettings from './settingComponent/apiSetting/ApiGlobalSettings';

const UserSettings = ({ isSidebarOpen }) => {
  const location = useLocation();

  return (
    <div className="set-meta-settings">
      {isSidebarOpen ? <Sidebar /> : <CloseSidebar />}

      <AppTransition>
        <Helmet>
          <title>Bumpups</title>
          <meta name="description" content="Customize your Bumpups settings." />
        </Helmet>

        <div className="set-top-nav-bar">
          <div className="set-top-nav-title">Settings</div>
          <NavLink to="/settings" end className={({ isActive }) => isActive ? 'set-nav-item active' : 'set-nav-item'}>Account</NavLink>
          <NavLink to="/settings/creator" className={({ isActive }) => isActive ? 'set-nav-item active' : 'set-nav-item'}>Creator</NavLink>
          <NavLink to="/settings/plan" className={({ isActive }) => isActive ? 'set-nav-item active' : 'set-nav-item'}>Plan</NavLink>
          <NavLink to="/settings/api" className={({ isActive }) => isActive ? 'set-nav-item active' : 'set-nav-item'}>API</NavLink>
        </div>

        <div className="set-settings-content">
          <AppTransition key={location.key}>
            <Routes location={location}>
              <Route path="/" element={<AccountSettings />} />
              <Route path="creator" element={<CreatorSettings />} />
              <Route path="plan" element={<PlanSettings />} />
              <Route path="api" element={<ApiGlobalSettings />} />
              <Route path="*" element={<Navigate to="/settings" replace />} />
            </Routes>
          </AppTransition>
        </div>
      </AppTransition>
    </div>
  );
};

const AccountSettings = () => (
  <div className="set-account-settings-wrapper">
    <GeneralSettings />
    <IntegrationSetting />
    <PreferenceSetting />
    <WarningSetting />
  </div>
);

const CreatorSettings = () => (
  <div className="set-account-settings-wrapper">
    <DescriptionTemplate />
    <CommentTemplate />
  </div>
);

const PlanSettings = () => (
  <div className="set-account-settings-wrapper">
    <SelectedPlan />
  </div>
);

export default UserSettings;
